<div class="not-found-page">

	<div class="not-found-page__title">
		Страница не найдена
	</div>

	<a class="not-found-page__link" href="/">
		Вернуться на главную
	</a>

</div>
